import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose } from 'recompose'

import { get } from 'lodash'

import * as MessageSelectors from 'app/modules/message/selectors'
import * as EndUserSelectors from 'app/modules/endUser/selectors'

const mapStateToProps = () => {
  const getUserIpEmail = (state, endUser, conversationId, firstEndUserMessageSelector) => {
    const firstMessagesLoaded = MessageSelectors.firstMessagesLoaded(state, { conversationId })

    if (!firstMessagesLoaded) {
      return {}
    }

    const firstEndUserMessage = firstEndUserMessageSelector(state, { conversationId })

    const endUserMessageIp = firstEndUserMessage && firstEndUserMessage.getIn(['context', 'ip'])

    return {
      ip: endUserMessageIp,
      email: get(endUser, 'email')
    }
  }

  const firstEndUserMessageSelector = MessageSelectors.firstEndUserMessage()
  const endUserForConversationId = EndUserSelectors.makeEndUserForConversationIdSelector()

  return (state, props) => {
    const { conversationId } = props
    const endUser = endUserForConversationId(state, { conversationId })
    const result = getUserIpEmail(state, endUser, conversationId, firstEndUserMessageSelector)
    return result
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  actions: bindActionCreators(
    {
      ...props.actions
    },
    dispatch
  )
})

const withContactInfo = WrappedComponent => compose(connect(mapStateToProps, mapDispatchToProps))(WrappedComponent)

export default withContactInfo



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/withContactInfo.js